import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { translate } from '@ngneat/transloco';

@Pipe({
    name: 'dateAgo',
    pure: true
})
export class DateAgoPipe implements PipeTransform {
    transform(value?: Date, ...args: string[]): Date|string {
        if (!value) return '';

        const currentTime = moment();
        let time: any = moment(value);

        if (time.isSameOrAfter(currentTime)) {
            return translate('Сега');
        }

        if (args.length) {
            return args[0] in time && typeof time[args[0]] === 'function'
                ? time[args[0]].apply(time, args.slice(1))
                : time.format(args[0]).toString();
        }
        return time.toDate();
    }
}
